export default {"src":"/_next/static/media/0x50b7545627a5162f82a992c33b87adc75187b218.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};